<script setup lang="ts">

import type { ContentBlockProps } from "@/components/following/types";

import TextareaInputAlt from "@/dsComponents/inputs/TextareaInputAlt.vue";

const props = withDefaults(defineProps<ContentBlockProps>(), {
    content: "",
});
</script>

<template>
    <div class="content-block">
        <div class="content-block__inner">
            <TextareaInputAlt
                :model-value="content"
                :rows="5"
                read-only
                read-only-text-padding="0 var(--spacing-xs, 4px)"
                :read-only-expand-action="props.readOnlyExpandAction"
                :read-only-expand-label="props.readOnlyExpandLabel"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.content-block {
    background-color: var(--bg-white-0, #ffffff);
    border: 1px solid var(--stroke-soft-200, #dbdfe6);
    border-radius: var(--radius-md, 8px);
    box-shadow: 0 1px 2px 0 rgba(219, 223, 230, 0.25);
    overflow: hidden;
    padding: var(--spacing-md, 8px);
    width: 100%;

    &__inner {
        padding: var(--spacing-md, 8px) var(--spacing-xs, 4px);
    }
}
</style>
